import React, { useCallback } from "react";

import { TooltipIcon } from "components/InputCards/TooltipIcon";
import { NumberInput } from "components/Inputs/NumberInput";

export const RangeCard = ({
  description,
  label,
  value,
  onChange,
  disabled,
  max,
  min,
  partKey,
  optionKey,
}) => {
  const onSave = useCallback(
    (val) => {
      onChange({ changeData: { data: val, partKey, optionKey } });
    },
    [onChange, optionKey, partKey],
  );

  return (
    <>
      <TooltipIcon description={description} />
      {label && <h5>{label}</h5>}
      <div className="d-flex flex-nowrap align-items-center">
        <NumberInput
          initialValue={+value}
          onSave={onSave}
          min={min}
          max={max}
          disabled={disabled}
          classNames="w-100"
          allowOutsidePropagation={false}
          testId={`range-input-${partKey}-${optionKey}`}
        />
        <span
          className="ms-2 font-size-sm text-gray-500 text-end"
          style={{ minWidth: "70px" }}
        >
          {min}&nbsp;...&nbsp;{max}
        </span>
      </div>
    </>
  );
};
